import { colors } from '../colors';

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer style={{ backgroundColor: colors.primary, color: colors.secondary, padding: '2rem', textAlign: 'center' }}>
            <p>© {year} Planna - All Rights Reserved</p>
            {/* Add social media links or other footer content here */}
        </footer>
    );
};

export default Footer;
